import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { loginGuard } from 'app/guards/login.guard';
import { blueprintsGuard } from './app.resolver';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'blueprints',
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadChildren: async () => (await import('./auth/auth.module')).AuthModule,
    data: { title: 'UGOL.Авторизация' },
  },
  {
    path: 'blueprints',
    canActivate: [blueprintsGuard],
    loadChildren: async () =>
      (await import('./modules/ugol-blueprints/ugol-blueprints.module')).UgolBlueprintsModule,
    data: { title: 'Чертежи' },
  },
  {
    path: '**',
    redirectTo: 'blueprints',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
